export default __webpack_public_path__ + "static/media/Jj.1787da33.wav";